import { useEffect } from 'react';
import {
  useAgentForgeMessages,
  useAgentForgeStream,
  useBarKeyboardShortcut,
} from '../hooks';
import { useSessionsQuery } from '../api';
// import { AgentForgeBar } from './bar';
// import { AgentForgeFullscreen } from './panel';
// import ThreadContainer from '../threadContainer';
import { HistoryPanel } from './history';
import { useAgentForgeStore } from '../stores';

// Single mount point for the whole feature. PrivateRoutes renders just this
// one component behind the feAgentForgeV1 flag — every surface (bar, thread,
// fullscreen, history) reads its own visibility from the Zustand store.
//
// Two background concerns are mounted here exactly once, matching legacy
// `/agentforge` exactly:
//
//   • WS subscriber (`useAgentForgeStream`). Single mount so each frame
//     is applied once. Drives live streaming + invalidates the messages
//     query on `stream_done`.
//
//   • Persisted-transcript fetcher (`useAgentForgeMessages`). Initial GET
//     on session open + re-fetch on stream-hook invalidation. Mirrors
//     into Zustand `messagesBySession`.
//
// No polling — legacy doesn't poll either. If the WS drops, the
// reconnect loop in `useAgentForgeWS` brings it back (1s → 30s backoff
// + tab-visibility resume); in-flight replies pause until then.
//
// NOTE: The product-wide AgentForgeBar (bottom dock) is temporarily
// disabled. The overlay `<ThreadContainer />` and `<AgentForgeFullscreen />`
// were the bar's pop-out / fullscreen surfaces — without the bar, they
// have no trigger, but they self-render whenever a tab exists and bleed
// onto unrelated routes (e.g. /jobs). Commented out alongside the bar
// import + JSX. The /agent route page mounts its own inline
// <ThreadContainer layout="inline" />, so /agent is unaffected.
//
// HistoryPanel stays mounted globally — its visibility is gated by
// `historyOpen` in the store, which only the chat surface's UI ever
// toggles, so it never appears on unrelated routes.
export const AgentForge = () => {
  const activeSessionId = useAgentForgeStore((s) => s.activeSessionId);
  const openTabs = useAgentForgeStore((s) => s.openTabs);
  const openTab = useAgentForgeStore((s) => s.openTab);
  useBarKeyboardShortcut();
  useAgentForgeStream(activeSessionId);
  useAgentForgeMessages(activeSessionId);

  // Deep-link backfill: when the user lands on `/agent/c/<id>` (refresh
  // or pasted URL) and we don't have a tab for that session, look it up
  // in the sessions list and open one. Without this, the header falls
  // back to "New chat" with no timestamp.
  const sessionsQuery = useSessionsQuery({ enabled: !!activeSessionId });
  useEffect(() => {
    if (!activeSessionId) return;
    if (openTabs.some((t) => t.sessionId === activeSessionId)) return;
    const session = sessionsQuery.data?.find((s) => s.id === activeSessionId);
    if (!session) return;
    openTab({
      sessionId: session.id,
      title: session.title || 'Untitled chat',
      status: 'idle',
      createdAt: session.created_at,
    });
  }, [activeSessionId, openTabs, sessionsQuery.data, openTab]);

  return (
    <>
      {/* <AgentForgeBar /> */}
      {/* <ThreadContainer /> */}
      {/* <AgentForgeFullscreen /> */}
      <HistoryPanel />
    </>
  );
};
